import {
  APPEND_OPERATOR_PURCHASE_DETAILS,
} from "./constants";
import {  openNotificationWithIcon } from "appRedux/actions/Common";


export const appendOperatorPurchaseDetails = (data) => {
  return (dispatch) => {
    openNotificationWithIcon("Amount & Units added successfully", "Success");
    dispatch({
      type: APPEND_OPERATOR_PURCHASE_DETAILS,
      payload: data,
    });
  };
};

